import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProcurementService } from '../../_services/procurement.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { Request } from '../../_model/procurement/Request';
import { User } from '../../_model/user';

@Component({
  selector: 'app-approve-dialog',
  templateUrl: './approve-dialog.component.html',
  styleUrls: ['./approve-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class ApproveDialogComponent implements OnInit {

  currentUser: User;

  constructor(
    public dialogRef: MatDialogRef<ApproveDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Request,
    private authService: AuthenticationService,
    private procurementService: ProcurementService,
    private toastr: ToastrService
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
  }

  closeModal() {
    this.dialogRef.close();
  }

  approveRequest() {
    const request = {
      employeeId: this.currentUser.employeeId,
      operationRecordId: this.data.id,
      operationTableName: 'PURCHASE_ORDER' // Procurement için tablo adı
    };

    this.procurementService.approveRequest(request).subscribe({
      next: (result) => {
        this.toastr.success('Onaylama işlemi başarılı', '');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.toastr.error(error.error?.msg || 'Onaylama işlemi başarısız', 'Hata');
        this.dialogRef.close(false);
      }
    });
  }
}
